(function () {
    'use strict';

    angular.module("imApp").factory("coopsService", ['$ihttp', function ($ihttp) {
        let service = {
            listCoops: function (parms) {
                return $ihttp.post({
                    method: 2727,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
